import { FC, Fragment } from "react";
import React from "react";
import { ChangeNames } from "../../clients/FirebaseClient/types";
import { useFormModel } from "../core/FormModelHelpes";
import { BoxedInputWithIconAndOptionalSwitch } from "../core/BoxedInputWithIconAndOptionalSwitch";
import { GasIcon } from "../core/icons/Icons";
import { NumberInput } from "../core/NumberField";
import { Colors } from "../../styles";
import { useStyles } from "../../useStyles";
import { createStyles, makeStyles, InputLabel } from "@material-ui/core";

const textStyles = makeStyles(() =>
    createStyles({
        pText: {
            color: Colors.anthracite,
            fontStretch: "normal",
            fontFamily: "innogyWEB",
            fontSize: 22,
            fontWeight: 300,
            fontStyle: "normal",
            lineHeight: 1.27,
            letterSpacing: "normal",
        },
    }),
);

export const ModificationGasRelocationDistanceForm: FC = () => {
    const classes = useStyles();
    const classes2 = textStyles();
    const { values, setValues } = useFormModel<ChangeNames.MODIFICATION_GAS_RELOCATION_DISTANCE>();
    return (
        <Fragment>
            <h3 className={classes.h3} style={{ marginTop: 28, marginBottom: 16 }}>
                Gasnetzanschluss
            </h3>
            <BoxedInputWithIconAndOptionalSwitch
                icon={<GasIcon />}
                content={
                    <Fragment>
                        <p className={classes.label} style={{ marginBottom: 8 }}>
                            Umlegung der Gasnetzanschlussleitung
                        </p>
                        <p className={classes2.pText} style={{ marginTop: 0, marginBottom: 24 }}>
                            Um wieviele Meter soll die Gas-Hausanschlussleitung auf dem
                            Privatgrundstück umgelegt werden?
                        </p>
                        <InputLabel className={classes.labledTextfieldLabel}>
                            Leitungslänge
                        </InputLabel>
                        <NumberInput
                            className={classes.textField}
                            fixedDecimalScale={false}
                            allowLeadingZeros={false}
                            decimalScale={values.modificationGasRelocationDistance.value.precision}
                            isNumericString={false}
                            allowNegative={false}
                            thousandSeparator="."
                            decimalSeparator=","
                            adornment={values.modificationGasRelocationDistance.value.unit}
                            value={values.modificationGasRelocationDistance.value.amount.num || ""}
                            placeholder="0"
                            onValueChange={v =>
                                setValues(values => {
                                    values.modificationGasRelocationDistance.value.amount.num =
                                        v.floatValue || null;
                                })
                            }
                            error={values.modificationGasRelocationDistance.error !== null}
                        />
                    </Fragment>
                }
            />
        </Fragment>
    );
};
